// extracted by mini-css-extract-plugin
export var description = "HealthPartner-module--description---OiTE";
export var headerSection = "HealthPartner-module--headerSection--vX68e";
export var healthPartnerWrapper = "HealthPartner-module--healthPartnerWrapper--k8kX2";
export var logoSection = "HealthPartner-module--logoSection--wb0vc";
export var subtitle = "HealthPartner-module--subtitle--emZ3A";
export var title = "HealthPartner-module--title--u+AkJ";